import debug from 'debug';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';
import Modal from 'Minetilbud/Shared/Components/overlay/modal'
import LoginOverlay from '../../login-overlay/login-overlay';

const log = debug('FrontPageFavoritesOverlay:Render:LoginForm');

class LoginForm extends Modal {
	constructor(instanceId, customerId) {
		super(instanceId);

		this.customerId = customerId;
	}

	async get() {
		const template = document.querySelector('[data-js="login-overlay-template"]');

		const container = this.create({
			baseClass: 'login-form',
			view: template.innerHTML
		});

		return container;
	}

	initialize() {
		const element = document.querySelector('[data-js="login-overlay"]');
		const search = queryString.Search();
		let redirectUrl = location.pathname;
		
		if (search.length > 0) {
			redirectUrl = redirectUrl + '?' + search + '&favorite=' + this.customerId;
		} else {
			redirectUrl = redirectUrl + '?favorite=' + this.customerId;
		}

		const loginForm = new LoginOverlay(element, redirectUrl);
	}

}

export default LoginForm;
